// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.communication-summary--container {
  min-height: 400px;
}

::ng-deep .k-tabstrip-items .k-link {
  padding-top: 10px;
  padding-bottom: 0;
}

::ng-deep .k-badge-edge.k-top-end {
  transform: translate(0, 0);
}`, "",{"version":3,"sources":["webpack://./src/app/shared/survey/components/communication-summary/communication-summary.component.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;AACF;;AAEA;EACE,iBAAA;EACA,iBAAA;AACF;;AAEA;EACE,0BAAA;AACF","sourcesContent":[".communication-summary--container {\r\n  min-height: 400px;\r\n}\r\n\r\n::ng-deep .k-tabstrip-items .k-link {\r\n  padding-top: 10px;\r\n  padding-bottom: 0;\r\n}\r\n\r\n::ng-deep .k-badge-edge.k-top-end {\r\n  transform: translate(0,0);\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
